export default __webpack_public_path__ + "static/Logo_Branco_Amarelo-1e2fda42326c666e2d6ad63e638fb5f3.png";